import { useRouter } from 'next/router';
import React from 'react';
import { useOauth } from '@peloton/auth';
import { toLocaleFromHostname } from '@peloton/internationalize';
import { LoginPage } from '@engage/auth/oauthFragment';
import { OAUTH_ORIGIN, OAUTH_REDIRECT_URI, PELOTON_PLATFORM } from '@webtv/env';
import useOauthEnabled from './useOauthEnabled';

var useLogin = function useLogin() {
  var _useOauth = useOauth(),
      loginWithRedirect = _useOauth.loginWithRedirect;

  var router = useRouter();
  var oauthEnabled = useOauthEnabled();
  var login = React.useCallback(function () {
    if (oauthEnabled) {
      loginWithRedirect({
        redirectUri: OAUTH_REDIRECT_URI,
        fragment: JSON.stringify({
          type: LoginPage.WebTV,
          message: '',
          locale: toLocaleFromHostname(),
          origin: OAUTH_ORIGIN,
          device: PELOTON_PLATFORM
        })
      });
    } else {
      router.push({
        pathname: '/login'
      });
    }
  }, [loginWithRedirect, oauthEnabled, router]);
  return login;
};

export default useLogin;